import React from 'react';
import Typography from '@mui/material/Typography';

const CustomTypography = ({ type, children,props }) => {
  const color = '#3E3F4C';  // Base color

  // Define styles for different types of typography
  const getTypographyStyles = (type) => {
    switch (type) {
      case 'heading':
        return {
          fontSize: '24px',
          fontWeight: 600,  // Semi-bold
          color: `${color}E6`,  // 90% opacity of the color (hex + opacity)
        };
      case 'subheading':
        return {
          fontSize: '18px',
          fontWeight: 500,  // Medium weight
          color: `${color}E6`,  // 90% opacity of the color (hex + opacity)
        };
      case 'label':
        return {
          fontSize: '15px',
          fontWeight: 500,  // Medium weight
          color: `${color}E6`,  // 90% opacity of the color (hex + opacity)
        };
      case 'bold':
        return {
          fontSize: '18px',
          fontWeight: 700,  // Bold weight
          color: `${color}E6`,  // 90% opacity of the color (hex + opacity)
        };
      case 'semiBold':
        return {
          fontSize: '15px',
          fontWeight: 600,  // Semi-bold weight
          color: `${color}E6`,  // 90% opacity of the color (hex + opacity)
        };
      default:
        return {};
    }
  };

  return (
    <Typography
      sx={{
        ...getTypographyStyles(type),
        ...props
      }}
    >
      {children}
    </Typography>
  );
};

export default CustomTypography;
